import { Component, Input } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'previous-period-footer',
  templateUrl: './previous-period-footer.component.html',
  styleUrls: ['./previous-period-footer.component.scss'],
})
export class PreviousPeriodFooterComponent {
  @Input()
  isLoading = false;

  @Input()
  data: string;

  @Input()
  percentage: number;

  @Input()
  previous: number;

  @Input()
  current: number;

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}
